module.exports = __webpack_public_path__ + "d2ea13f1a68997e5aff9aeb378d8f454.svg";